import { styled } from '@mui/material';
import { type SlideoutDrawerProps } from './types.ts';

export const DrawerHeader = styled('div', { shouldForwardProp: prop => prop !== 'anchor' })<{
  anchor: SlideoutDrawerProps['anchor'];
}>(({ anchor, theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.grey[900],
  borderBottom: `1px solid ${theme.palette.grey[800]}`,
  display: 'flex',
  flexDirection: anchor === 'left' ? 'row-reverse' : undefined,
  justifyContent: anchor === 'left' ? 'space-between' : undefined,
  left: 0,
  padding: theme.spacing(1),
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 3,
}));

export const Container = styled('div')();
